import SupportedInterval from './SupportedInterval';
export default SupportedInterval;